export const PRICING_PLANS = Object.freeze({
  MONTHLY: 'monthly',
  ANNUAL: 'annual',
  EDUCATION: 'educational',
})

export const DISCOUNT_RATE = Object.freeze({
  DEFAULT: 0.1,
  MORE_THAN_3_LICENSES: 0.2,
  LEGACY_1: 0.25,
  LEGACY_2: 0.3,
  LEGACY_3: 0.4,
})

export const UPGRADE_LOCATION = Object.freeze({
  PRICING: 'pricing-plan',
  COMPARE_PLANS: 'compare-plans',
})

export const LIST_PERSONAL_MAIL = [
  'gmail.',
  'yahoo.',
  'hotmail.',
  'outlook.',
  'live.',
  'aol.',
  'icloud.',
  'msn.',
  'protonmail.',
  'yandex.',
  'zohomail.',
  'mail.',
  'qq.',
  '163.',
  '126.',
  'gmx.',
]
